// ─── Imports ────────────────────────────────────────────────────────────────
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Tooltip } from "@mui/material";

import Styles from "./SideNavBar.module.css";
import sidebarCompanyIcon from "../../assets/images/companIcon.svg";
import panelClose from "../../assets/images/panelClose.svg";

import { ReactComponent as UserRoundPen } from "../../assets/images/UserRoundPen.svg";
import { ReactComponent as Bess } from "../../assets/images/bessIcon.svg";
import { ReactComponent as BessOrange } from "../../assets/images/BessOrange.svg";
import { ReactComponent as ArcIcon } from "../../assets/images/arcIcon.svg";
import { ReactComponent as LccIcon } from "../../assets/images/lccIcon.svg";
import { ReactComponent as BuySell } from "../../assets/images/buySellGrey.svg";
import { ReactComponent as BuySellOrange } from "../../assets/images/buySellOrnage.svg";
import { ReactComponent as DiscomIconGrey } from "../../assets/images/BankingGrey.svg";
import { ReactComponent as BankingOrange } from "../../assets/images/BankingOrange.svg";
import { ReactComponent as ConsumerGrey } from "../../assets/images/consumerGrey.svg";
import { ReactComponent as CompanyAdminIconGrey } from "../../assets/images/compAdminGrey.svg";
import { ReactComponent as CompanyAdminIconOrange } from "../../assets/images/compAdminOrangesvg.svg";
import { ReactComponent as ConsumerOrange } from "../../assets/images/ConsumerOrange.svg";
import { ReactComponent as GeneratorOrange } from "../../assets/images/GeneratorOrange.svg";
import { ReactComponent as BankingLedgerOrange } from "../../assets/images/BankingLedgerOrange.svg";
import { ReactComponent as BankingLedgerGrey } from "../../assets/images/BankingLedgerGrey.svg";
import { ReactComponent as SearchBankingOrange } from "../../assets/images/SeaBankOrange.svg";
import { ReactComponent as SearchBankingGrey } from "../../assets/images/SeaBankGrey.svg";
import { ReactComponent as ProfileOrange } from "../../assets/images/profileOrange.svg";
import { ReactComponent as EscrowOrange } from "../../assets/images/escrowOrange.svg";
import { ReactComponent as EscrowGrey } from "../../assets/images/escrowGrey.svg";
import { ReactComponent as ArchiveOrange } from "../../assets/images/archiveOrange.svg";
import { ReactComponent as LccOrange } from "../../assets/images/LCCorange.svg";
import { ReactComponent as LccGrey } from "../../assets/images/LCCgrey.svg";
import { ReactComponent as RfqGrey } from "../../assets/images/rfqGrey.svg";
import { ReactComponent as RfqOrange } from "../../assets/images/rfqOrange.svg";
import { ReactComponent as ReverseAucGrey } from "../../assets/images/reverseAucGrey.svg";
import { ReactComponent as ReverseAucOrange } from "../../assets/images/reverseAucOrange.svg";
import { ReactComponent as BilateralGrey } from "../../assets/images/bilateralGrey.svg";
import { ReactComponent as BilateralOrange } from "../../assets/images/bilateralAnotherOrange.svg";
import { ReactComponent as VppaGrey } from "../../assets/images/vpGrey.svg";
import { ReactComponent as VppaOrange } from "../../assets/images/vpOrange.svg";
import { ReactComponent as RecGrey } from "../../assets/images/recGrey.svg";
import { ReactComponent as RecOrange } from "../../assets/images/recOrange.svg";
import { ReactComponent as GenIconGrey } from "../../assets/images/genIconGrey.svg";
import { ReactComponent as LogoutIcon } from "../../assets/images/logoutGrey.svg";
import { ReactComponent as LogoutIconHover } from "../../assets/images/logoutOrange.svg";
import RaDateCHange from "../Modals/RaDateChange/RaDateCHange";

import { loginSwitchService } from "../../Services/ApiCalling/Auth";
import { activeLoading } from "../../Redux/Slices/notificationSlice";
import { login, logout } from "../../Redux/Slices/authSlice";
import { ErrorMessage } from "../../commons/Toast/ErrorMessage";
import {
  emptyCounterPartyList,
  emptySelfList,
  fetchSelfCapacity,
  fetchSideBarList,
  setActiveListingId,
} from "../../Redux/Slices/CapacitySlice";
import { setActiveRegion } from "../../Redux/Slices/activeRegionSlice";
import { setActiveEntity } from "../../Redux/Slices/activeEntitySlice";
import { fetchUserPaymentConfig } from "../../Redux/Slices/platformSlice";

// ─── Config Helpers ──────────────────────────────────────────────────────────

const getProducts = ({ user, state, mapingProduct }) => {
  const isQaOrStage =
    process.env.REACT_APP_ENV === "qa" || process.env.REACT_APP_ENV === "stage";

  const allProducts = [
    {
      user: "banking",
      name: "Banking",
      link: "/banking",
      Icon: DiscomIconGrey,
      HoverIcon: BankingOrange,
      productId: "1",
      firstChild: [
        {
          name: "Dashboard",
          link: "/banking",
          Icon: DiscomIconGrey,
          HoverIcon: BankingOrange,
        },
        {
          name: "My Banking Ledger",
          link: "/banking_ledger",
          Icon: BankingLedgerGrey,
          HoverIcon: BankingLedgerOrange,
        },
        {
          name: "Available Banking",
          link: "/banking_search",
          Icon: SearchBankingGrey,
          HoverIcon: SearchBankingOrange,
        },
      ],
    },
    {
      user,
      name: user === "consumer" || user === "CONSUMER" ? "Buy" : "Sell",
      link: "/dashboard",
      Icon: BuySell,
      HoverIcon: BuySellOrange,
      productId: "2",
      firstChild: [
        {
          view: true,
          name: "Bilateral",
          link: "/dashboard",
          Icon: BilateralGrey,
          HoverIcon: BilateralOrange,
          children: [
            {
              name:
                user === "consumer" || user === "CONSUMER"
                  ? "All Sell Listings"
                  : "All Buy Listings",
              link: "/search_listing",
              Icon: SearchBankingGrey,
              HoverIcon: SearchBankingOrange,
            },
          ],
        },
        {
          view: mapingProduct?.find((ele) => ele?.productName === "RFP_RFQ")
            ?.productId
            ? true
            : false,
          name: "RFP/RFQ",
          link: "/rfq",
          Icon: RfqGrey,
          HoverIcon: RfqOrange,
        },
        {
          view: mapingProduct?.find((ele) => ele?.productName === "RA")
            ?.productId
            ? true
            : false,
          name: "Reverse Auction",
          link: "/reverse_auction",
          Icon: ReverseAucGrey,
          HoverIcon: ReverseAucOrange,
        },
        {
          view: mapingProduct?.find(
            (ele) => ele?.productName === "TRADE_CONNECT",
          )?.productId
            ? true
            : false,
          name: "TradeConnect",
          link: "/tradeconnect",
          Icon: RfqGrey,
          HoverIcon: RfqOrange,
          children: [
            {
              name: "RFP/RFQ",
              link: "/tradeconnect",
              Icon: RfqGrey,
              HoverIcon: RfqOrange,
            },
            {
              name: "Reverse Auction",
              link: "/reverse_auction",
              Icon: ReverseAucGrey,
              HoverIcon: ReverseAucOrange,
            },
          ],
        },
      ],
    },
    {
      name: "BESS",
      link: "/bess",
      Icon: Bess,
      HoverIcon: BessOrange,
      productId: "3",
      firstChild: [],
    },
    {
      name: "REC",
      link: "/rec",
      Icon: RecGrey,
      HoverIcon: RecOrange,
      productId: "4",
      firstChild: [],
    },
    {
      name: "VPPA",
      link: "/vppa",
      Icon: VppaGrey,
      HoverIcon: VppaOrange,
      productId: "5",
      firstChild: [],
    },
  ];

  const filteredProducts = allProducts.map((product) => ({
    ...product,
    firstChild:
      product.firstChild?.filter((child) => child.view !== false) ?? [],
  }));

  if (user === "COMPANY_ADMIN") return [];
  return user === "BANKING"
    ? filteredProducts.filter((p) => p.productId === "1")
    : filteredProducts.filter((p) => p.productId !== "1");
};

const getProfileOptions = ({ user }) => {
  const allOptions = [
    {
      name: "My Profile",
      link: "/my_profile",
      Icon: UserRoundPen,
      HoverIcon: ProfileOrange,
      role: ["CONSUMER", "GENERATOR", "BANKING"],
    },
    {
      name: "Escrow",
      link: "/wallet",
      Icon: EscrowGrey,
      HoverIcon: EscrowOrange,
      role: ["CONSUMER", "GENERATOR"],
    },
    {
      name: "Archive",
      link: "/archive",
      Icon: ArcIcon,
      HoverIcon: ArchiveOrange,
      role: ["CONSUMER", "GENERATOR", "BANKING"],
    },
    {
      name: "Unified Ledger",
      link: "/unified_ledger",
      Icon: LccIcon,
      HoverIcon: LccOrange,
      role: ["CONSUMER", "GENERATOR"],
    },
    {
      name: " Logout",
      direct: true,
      Icon: LogoutIcon,
      HoverIcon: LogoutIconHover,
      role: ["CONSUMER", "GENERATOR", "BANKING"],
    },
  ];

  return allOptions.filter((opt) => opt.role.includes(user));
};

const getRedirectPath = (role) => {
  const paths = {
    SUPER_ADMIN: "/admin_dashboard",
    MAKER: "/admin_dashboard",
    CHECKER: "/admin_dashboard",
    ADMIN: "/admin_dashboard",
    ANALYST: "/analyst_dashboard",
    TRADER: "/trader_dashboard",
    BANKING: "/banking",
    COMPANY_ADMIN: "/admin_company_dashboard",
    CONSUMER: "/dashboard",
    GENERATOR: "/dashboard",
  };
  return paths[role] || "/dashboard";
};

const getRoleConfig = ({ name, consumers, generators, discoms }) => {
  const configs = {
    COMPANY_ADMIN: {
      name: "Company Admin",
      icon: CompanyAdminIconGrey,
      hoverIcon: CompanyAdminIconOrange,
      role: "COMPANY_ADMIN",
    },
    BANKING: {
      name: "Banking",
      list: discoms,
      icon: DiscomIconGrey,
      hoverIcon: BankingOrange,
      role: "BANKING",
    },
    CONSUMER: {
      name: "Buyer",
      list: consumers,
      icon: ConsumerGrey,
      hoverIcon: ConsumerOrange,
      role: "CONSUMER",
    },
    GENERATOR: {
      name: "Seller",
      list: generators,
      icon: GenIconGrey,
      hoverIcon: GeneratorOrange,
      role: "GENERATOR",
    },
  };
  return configs[name] || name;
};

const getEntityDetails = (item) => ({
  id: item.consumerId || item.generatorId || item.discomId,
  name: item.consumerName || item.generatorName || item.discomName,
});

// ─── Helper ──────────────────────────────────────────────────────────────────

/**
 * Recursively checks whether `pathname` matches a node or any of its
 * descendants (firstChild / children arrays).
 * Leaf nodes (no children) use exact match only to prevent false positives.
 */
const isPathUnderNode = (node, pathname) => {
  const kids = node.firstChild ?? node.children ?? [];
  if (kids.length === 0) return pathname === node.link;
  if (pathname === node.link) return true;
  return kids.some((child) => isPathUnderNode(child, pathname));
};

// ─── Sub-components ──────────────────────────────────────────────────────────

const EntityList = ({ ele, activeRole, activeEntity, handleSwitchUser }) => {
  const [activeHover, setActiveHover] = useState("");
  const activeItemRef = useRef(null);

  const activeEntityId =
    ele.role === "CONSUMER"
      ? activeEntity?.consumerId
      : ele.role === "GENERATOR"
        ? activeEntity?.generatorId
        : activeEntity?.discomId;

  useEffect(() => {
    activeItemRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, [activeEntity]);

  return ele.list.map((item) => {
    const { name } = getEntityDetails(item);
    const id =
      ele.role === "CONSUMER"
        ? item.consumerId
        : ele.role === "GENERATOR"
          ? item.generatorId
          : item.discomId;

    const isCurrentEntity =
      !!activeEntityId && activeRole === ele.role && activeEntityId === id;
    const isHighlighted = isCurrentEntity || activeHover === id;

    return (
      <div
        key={id}
        ref={isCurrentEntity ? activeItemRef : null}
        className={`display_flex_row_gap_8_only ${Styles.eachElementName}`}
        onMouseEnter={() => setActiveHover(id)}
        onMouseLeave={() => setActiveHover("")}
        onClick={() =>
          handleSwitchUser({ role: ele.role, id, displayName: name })
        }
      >
        <div
          className={
            isHighlighted ? Styles.activeViewNotif : Styles.inActiveViewNotif
          }
        />
        <div
          className={
            isHighlighted ? Styles.activeEntityName : Styles.inactiveEntityname
          }
        >
          {name}
        </div>
      </div>
    );
  });
};

const EntityMain = ({
  ele,
  activeUser,
  activeHover,
  activeExpanded,
  handleHover,
  handleExpanded,
  activeEntity,
  handleSwitchUser,
  navOpen,
  onNavSwitch,
  company,
}) => {
  const isCurrRole = activeUser?.activeRole === ele.role;
  const isExpanded = activeExpanded === ele.role;
  const isActive = isCurrRole || ele.role === activeHover || isExpanded;
  const Icon = isActive ? ele.hoverIcon : ele.icon;

  const activeName = ele.list?.find((i) =>
    ele.role === "CONSUMER"
      ? i.consumerId === activeUser?.activeConsumerId
      : ele.role === "GENERATOR"
        ? i.generatorId === activeUser?.activeGeneratorId
        : i.discomId === activeUser?.activeDiscomId,
  );

  if (!navOpen) {
    return (
      <div
        onMouseEnter={() => handleHover(ele.role)}
        onMouseLeave={() => handleHover("")}
        onClick={() =>
          ele.role === "COMPANY_ADMIN"
            ? handleSwitchUser({ role: ele.role })
            : onNavSwitch()
        }
        className={`${Styles.entityCollapsedConainter} ${isActive && Styles.activeRoleContainer}`}
      >
        <Icon style={{ height: "16px", width: "16px" }} />
        <div className={Styles.collapseRoleName}>{ele.name}</div>
      </div>
    );
  }

  return (
    <>
      <div
        onMouseEnter={() => handleHover(ele.role)}
        onMouseLeave={() => handleHover("")}
        onClick={() => handleExpanded(ele.role)}
        className={`display_flex_row ${Styles.defaultRoleContainer} ${
          isActive
            ? Styles.roleMainContainer
            : Styles.roleMainContainer_inactive
        } ${isExpanded && ele.list?.length > 0 && Styles.containerSelectedMain}`}
      >
        <div className="display_flex_row_gap_8_only">
          <div
            className={
              isActive ? Styles.activeViewNotif : Styles.inActiveViewNotif
            }
          />
          <Icon style={{ height: "16px", width: "16px" }} />

          {isCurrRole ? (
            <div className={Styles.activeRoleDetails}>
              <div className={Styles.activeSelectedName}>{ele.name}</div>
              <div className={Styles.activeDisplayName}>
                {ele.role === "CONSUMER"
                  ? activeName?.consumerName
                  : ele.role === "GENERATOR"
                    ? activeName?.generatorName
                    : activeName?.discomName ||
                      company?.companyName ||
                      "Entity Name"}
              </div>
            </div>
          ) : (
            <div
              className={
                isActive ? Styles.hoverDisplayName : Styles.normalDisplayName
              }
              onClick={(e) => {
                if (ele.role === "COMPANY_ADMIN") {
                  e.stopPropagation();
                  handleSwitchUser({ role: ele.role });
                }
              }}
            >
              {ele.name}
            </div>
          )}
        </div>

        {ele.list?.length > 0 && (
          <KeyboardArrowDownIcon
            style={{
              fontSize: "14px",
              color: isActive ? "#f1935c" : "#617499",
              rotate: isExpanded ? "180deg" : "0deg",
              transition: "rotate 0.3s ease-in-out",
            }}
          />
        )}
      </div>

      {isExpanded && ele.list?.length > 0 && (
        <div
          className={
            isExpanded ? Styles.entityContainer : Styles.entityEmptyContainer
          }
        >
          <EntityList
            ele={ele}
            activeRole={activeUser?.activeRole}
            activeEntity={activeEntity}
            handleSwitchUser={handleSwitchUser}
          />
        </div>
      )}
    </>
  );
};

const ExpandedProduct = ({ data, expanded, handleNav, navOpen }) => {
  const location = useLocation();

  const initExpanded = (items) => {
    const map = {};
    items?.forEach((ele) => {
      map[ele.name] = isPathUnderNode(ele, location.pathname);
    });
    return map;
  };

  const [expandedMap, setExpandedMap] = useState(() => initExpanded(data));
  const [activeHover, setActiveHover] = useState("");

  // Sync expandedMap when URL changes — open matching, close non-matching
  useEffect(() => {
    setExpandedMap(() => initExpanded(data));
  }, [location.pathname]);

  const toggleItem = (name) =>
    setExpandedMap((prev) => ({ ...prev, [name]: !prev[name] }));

  // ── Collapsed nav ──
  if (!navOpen) {
    return (
      <div className={Styles.collapsedContainer}>
        {data?.map((ele) => {
          const isChildActive = isPathUnderNode(ele, location.pathname);
          const active = activeHover === ele.name || isChildActive;
          const Icon = active ? ele.HoverIcon : ele.Icon;

          return (
            <div
              key={ele.name}
              className={`display_flex_row ${Styles.productCollapsedContainer} ${active && Styles.productCollapsedContainerActive}`}
              onMouseEnter={() => setActiveHover(ele.name)}
              onMouseLeave={() => setActiveHover("")}
              onClick={() => {
                toggleItem(ele.name);
                handleNav(ele.link);
              }}
            >
              <Icon style={{ height: "16px", width: "16px" }} />
              <div>{ele.name}</div>
            </div>
          );
        })}
      </div>
    );
  }

  // ── Expanded nav ──
  return (
    <div
      className={
        expanded
          ? Styles.productListContainer
          : Styles.productListContainerCollapsed
      }
    >
      <div className={`scroll_bar_y ${Styles.expandedProductMainContainer}`}>
        {data?.map((ele) => {
          const isChildActive = isPathUnderNode(ele, location.pathname);
          const active = activeHover === ele.name || isChildActive;
          const isItemExpanded = !!expandedMap[ele.name];
          const Icon = active ? ele.HoverIcon : ele.Icon;
          const kids = ele.children ?? [];

          return (
            <React.Fragment key={ele.name}>
              <div
                className={`display_flex_row ${Styles.expandedProductNavList}`}
              >
                <div
                  className={`display_flex_row_gap_8_only ${Styles.eachElementName}`}
                  onMouseEnter={() => setActiveHover(ele.name)}
                  onMouseLeave={() => setActiveHover("")}
                  onClick={() => {
                    toggleItem(ele.name);
                    handleNav(ele.link);
                  }}
                >
                  <div
                    className={
                      active ? Styles.activeViewNotif : Styles.inActiveViewNotif
                    }
                  />
                  <div
                    className={`display_flex_row_gap_8_only ${active && Styles.activeEntityName}`}
                  >
                    <Icon style={{ height: "16px", width: "16px" }} />
                    <div>{ele.name}</div>
                  </div>
                </div>

                {kids.length > 0 && (
                  <KeyboardArrowDownIcon
                    style={{
                      fontSize: "14px",
                      color:
                        isItemExpanded || isChildActive ? "#f1935c" : "#617499",
                      rotate: isItemExpanded ? "180deg" : "0deg",
                      transition: "rotate 0.3s ease-in-out",
                    }}
                  />
                )}
              </div>

              {isItemExpanded && kids.length > 0 && (
                <div className={Styles.expandedChildrenContainer}>
                  {kids.map((child) => {
                    const isChildHovered = activeHover === child.name;
                    const isChildPathActive = isPathUnderNode(
                      child,
                      location.pathname,
                    );
                    const isGCActive = isChildPathActive || isChildHovered;
                    const GCIcon = isGCActive ? child.HoverIcon : child.Icon;

                    return (
                      <div
                        key={child.name}
                        onMouseEnter={() => setActiveHover(child.name)}
                        onMouseLeave={() => setActiveHover("")}
                        onClick={() => handleNav(child.link)}
                        className={`display_flex_row_gap_8_only ${Styles.expandedChild} ${isGCActive && Styles.activeEntityName}`}
                      >
                        <GCIcon style={{ height: "16px", width: "16px" }} />
                        <div>{child.name}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

const ProductList = ({ data, navOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isPathActive = isPathUnderNode(data, location.pathname);

  const [expanded, setExpanded] = useState(isPathActive ? data.productId : "");
  const [activeHover, setActiveHover] = useState("");

  // Sync expanded state when URL changes — open if active, close if not
  useEffect(() => {
    setExpanded(isPathActive ? data.productId : "");
  }, [location.pathname]);

  const isExpanded = expanded === data.productId;
  const isHovered = activeHover === data.productId;
  const isActive = isPathActive || isHovered;
  const Icon = isActive ? data.HoverIcon : data.Icon;

  const handleExpanded = (id) => setExpanded((prev) => (prev === id ? "" : id));
  const handleNav = (link) => navigate(link);

  return (
    <div>
      <div
        onMouseEnter={() => setActiveHover(data.productId)}
        onMouseLeave={() => setActiveHover("")}
        className={
          navOpen
            ? `${Styles.productMainContainer} ${
                isExpanded
                  ? data.firstChild?.length > 0
                    ? Styles.productMainContainerExpanded
                    : Styles.productHovered
                  : ""
              } ${isHovered && Styles.productHovered}`
            : `${Styles.productCollapsedContainer} ${
                (isHovered || isPathActive) &&
                Styles.productCollapsedContainerActive
              } ${isExpanded && data.firstChild?.length > 0 && Styles.containerSelectedMain}`
        }
        onClick={() => {
          handleExpanded(data.productId);
          handleNav(data.link);
        }}
      >
        {navOpen ? (
          <>
            <div className="display_flex_row_gap_4_only">
              <div
                className={
                  isHovered || isExpanded
                    ? Styles.activeViewNotif
                    : Styles.inActiveViewNotif
                }
              />
              <Icon style={{ height: "16px", width: "16px" }} />
              <div
                className={`${Styles.productDisplayName} ${(isHovered || isExpanded) && Styles.productHoveredText}`}
              >
                {data.name}
              </div>
            </div>
            {data.firstChild?.length > 0 && (
              <KeyboardArrowDownIcon
                style={{
                  fontSize: "14px",
                  color: isExpanded ? "#f1935c" : "#617499",
                  rotate: isExpanded ? "180deg" : "0deg",
                  transition: "rotate 0.3s ease-in-out",
                }}
              />
            )}
          </>
        ) : (
          <>
            <Icon style={{ height: "16px", width: "16px" }} />
            <div>{data.name}</div>
          </>
        )}
      </div>

      {isExpanded && data.firstChild?.length > 0 && (
        <ExpandedProduct
          data={data.firstChild}
          expanded
          handleNav={handleNav}
          navOpen={navOpen}
        />
      )}
    </div>
  );
};

const ProfileList = ({ data, navOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [hover, setHover] = useState("");

  const handleLogout = () => {
    dispatch(logout());
    localStorage.setItem("OTC_V2_TOKEN", null);
    localStorage.clear();
    sessionStorage.clear();
    window.location = "/login";
  };

  return (
    <div className={Styles.profileListContainer}>
      {data.map((ele) => {
        const isActive = hover === ele.name || location.pathname === ele.link;
        const Icon = isActive ? ele.HoverIcon : ele.Icon;

        return (
          <div
            key={ele.name}
            className={
              navOpen
                ? `display_flex_row_gap_8_only ${Styles.profileItem} ${isActive ? Styles.activeProfileItem : ""}`
                : `${Styles.profileItemCollapsed} ${isActive ? Styles.activeProfileItemCollapsed : ""}`
            }
            onClick={() => (ele?.direct ? handleLogout() : navigate(ele.link))}
            onMouseEnter={() => setHover(ele.name)}
            onMouseLeave={() => setHover("")}
          >
            {navOpen && (
              <div
                className={
                  isActive ? Styles.activeViewNotif : Styles.inActiveViewNotif
                }
              />
            )}
            <Icon style={{ height: "16px", width: "16px" }} />
            <div>{ele.name}</div>
          </div>
        );
      })}
    </div>
  );
};

// ─── Main Component ──────────────────────────────────────────────────────────

const SideNavBar = ({ navOpen, onNavSwitch }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const entity = useSelector((s) => s.persistedReducer?.user);

  const company = useSelector((s) => s.persistedReducer.company);
  const stateLabel = useSelector((s) => s.persistedReducer.company?.stateLabel);
  const activeUser = useSelector((s) => s.persistedReducer.user);
  const sideBarList = useSelector((s) => s.CapacitySlice.fetchSideBarList);

  const mapingData = useSelector((s) => s?.platformSlice?.userPaymentConfigs);

  const [activeHover, setActiveHover] = useState("");
  const [activeExpanded, setActiveExpanded] = useState(
    activeUser?.activeRole || "",
  );
  const [raChange, setRaChange] = useState(false);

  useEffect(() => {
    dispatch(fetchSideBarList());
  }, [dispatch]);

  useEffect(() => {
    if (entity && entity.activeRole !== "COMPANY_ADMIN" && entity.activeRole !== "BANKING") {
      dispatch(
        fetchUserPaymentConfig({
          role: entity?.activeRole,
          entityId: entity?.activeConsumerId || entity?.activeGeneratorId,
          companyId: company?.companyId,
        }),
      );
    }
  }, [dispatch, entity]);

  const ROLE_ORDER = ["COMPANY_ADMIN", "BANKING", "CONSUMER", "GENERATOR"];
  const roles = (() => {
    const availableRoles = new Set(sideBarList?.roles ?? []);
    return ROLE_ORDER.filter((role) => availableRoles.has(role)).map((role) =>
      getRoleConfig({
        name: role,
        generators: sideBarList.generators || [],
        consumers: sideBarList.consumers || [],
        discoms: sideBarList.discoms || [],
      }),
    );
  })();

  const assignedProducts = getProducts({
    user: activeUser?.activeRole,
    state: stateLabel,
    mapingProduct: mapingData,
  });

  const commonProfile = getProfileOptions({ user: activeUser?.activeRole });

  const activeEntity = roles
    .find((r) => r.role === activeUser?.activeRole)
    ?.list?.find((i) =>
      activeUser?.activeRole === "CONSUMER"
        ? i.consumerId === activeUser?.activeConsumerId
        : activeUser?.activeRole === "GENERATOR"
          ? i.generatorId === activeUser?.activeGeneratorId
          : i.discomId === activeUser?.activeDiscomId,
    );

  const handleSwitchUser = async ({ role, id, displayName }) => {
    const payload = {
      switchRole: role,
      switchCompanyId: null,
      switchConsumerId: role === "CONSUMER" ? id : null,
      switchGeneratorId: role === "GENERATOR" ? id : null,
      switchDiscomId: role === "BANKING" ? id : null,
    };

    dispatch(activeLoading(true));
    const res = await loginSwitchService(payload);

    if (res?.data?.code === 200) {
      const { data } = res.data;
      dispatch(setActiveListingId(null));
      dispatch(emptyCounterPartyList());
      dispatch(emptySelfList());
      dispatch(login(data));
      dispatch(setActiveRegion(data.activeUserRegionName || ""));
      localStorage.setItem("OTC_V2_TOKEN", data.token);
      dispatch(setActiveEntity(displayName || ""));
      navigate(getRedirectPath(data.activeRole));
      setTimeout(() => {
        dispatch(activeLoading(false));
        window.location.reload();
      }, 2000);
      if (data.activeRole !== "COMPANY_ADMIN") {
        dispatch(fetchSelfCapacity({ user: data.activeRole.toLowerCase() }));
      }
    } else {
      dispatch(activeLoading(false));
      ErrorMessage(res?.data?.error || "Switch failed");
    }
  };

  const handleEntityExp = (val) =>
    setActiveExpanded((prev) => (prev === val ? "" : val));

  return (
    <>
      {raChange && (
        <RaDateCHange open={raChange} handleClose={() => setRaChange(false)} />
      )}

      <div className={Styles.sidebarMainContainer}>
        {/* Top: Company name + toggle */}
        <div
          className={
            navOpen
              ? `display_flex_row ${Styles.topNameContainer}`
              : `display_flex_column_gap_8 ${Styles.topNameContainer_collapsed}`
          }
        >
          {navOpen ? (
            <>
              <div className="display_flex_row_gap_8_only">
                <img
                  width={20}
                  height={20}
                  src={sidebarCompanyIcon}
                  alt="Icon"
                />
                <Tooltip
                  title={
                    <div className={Styles.tooltip}>{company?.companyName}</div>
                  }
                  arrow
                  placement="right"
                >
                  <span className={Styles.companyName}>
                    {company?.companyName || "Company Name"}
                  </span>
                </Tooltip>
              </div>
              <img
                width={18}
                height={18}
                src={panelClose}
                alt="Close"
                onClick={onNavSwitch}
                className="cursor_pointer"
                style={{ cursor: "pointer" }}
              />
            </>
          ) : (
            <>
              <img
                style={{ transform: "rotate(180deg)", cursor: "pointer" }}
                width={18}
                height={18}
                src={panelClose}
                alt="Open"
                onClick={onNavSwitch}
                className="cursor_pointer"
              />
              <img width={20} height={20} src={sidebarCompanyIcon} alt="Icon" />
              <Tooltip
                title={
                  <div className={Styles.tooltip}>{company?.companyName}</div>
                }
                arrow
                placement="right"
              >
                <span className={Styles.companyName_collapsed}>
                  {company?.companyName || "..."}
                </span>
              </Tooltip>
            </>
          )}
        </div>

        {/* Nav body */}
        <div
          className={
            navOpen
              ? Styles.navElementsMainContainer
              : Styles.navElementsMainContainerCollapsed
          }
        >
          {/* Entity section */}
          <div className={Styles.elementMainContainer}>
            <div
              className={
                navOpen ? Styles.elementHeading : Styles.elementHeadingCollapsed
              }
            >
              Entity
            </div>
            <div className={Styles.entitySelectionContainer}>
              {roles.map((ele) => (
                <EntityMain
                  key={ele.role}
                  ele={ele}
                  activeUser={activeUser}
                  activeHover={activeHover}
                  activeExpanded={activeExpanded}
                  handleHover={setActiveHover}
                  handleExpanded={handleEntityExp}
                  activeEntity={activeEntity}
                  handleSwitchUser={handleSwitchUser}
                  navOpen={navOpen}
                  onNavSwitch={onNavSwitch}
                  company={company}
                />
              ))}
            </div>
          </div>

          {/* Products + Profile sections */}
          {assignedProducts.length > 0 && (
            <>
              <div className={Styles.elementMainContainer}>
                <div
                  className={
                    navOpen
                      ? Styles.elementHeading
                      : Styles.elementHeadingCollapsed
                  }
                >
                  Products
                </div>
                <div className={Styles.entitySelectionContainer}>
                  {assignedProducts.map((ele) => (
                    <ProductList
                      key={ele.productId}
                      data={ele}
                      navOpen={navOpen}
                    />
                  ))}
                </div>
              </div>

              <div
                className={Styles.elementMainContainer}
                style={{ borderBottom: "0px" }}
              >
                <ProfileList data={commonProfile} navOpen={navOpen} />
              </div>
            </>
          )}
          {(process.env.REACT_APP_ENV === "qa" ||
            process.env.REACT_APP_ENV === "stage") && (
            <div
              onClick={() => setRaChange(true)}
              className={`activeButton ${Styles.raDateButton}`}
            >
              RA Date TESTING
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SideNavBar;
